import { render, staticRenderFns } from "./BasePdfViewerSignature.vue?vue&type=template&id=6f420038&scoped=true"
import script from "./BasePdfViewerSignature.vue?vue&type=script&lang=js"
export * from "./BasePdfViewerSignature.vue?vue&type=script&lang=js"
import style0 from "./BasePdfViewerSignature.vue?vue&type=style&index=0&id=6f420038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f420038",
  null
  
)

export default component.exports